import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlankLink from '../../../../common/BlankLink';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';

const SwitchT12ToT8Lights = ({
  t,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('On average, I use the lights about')}
        <InlineInput
          maxLength={2}
          apiKey={'input_takeaction_T12toT8_hours'}
        />
        {t('hours a day. I have')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_T12toT8_T8'}
        />
        {t('T12 lights that I will upgrade to T8 lights.')}
      </p>
    </div>
    <div className="action-details__links">
      {widgetSource !== 'ontario' &&
        <BlankLink
          href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BEligible+Applicants%253D%253DIndividual%255D%255BCategory%253D%253DEnergy%255D/false/none/false/1/12"
          text={t('Find rebates and incentives for this action')}
        />
      }
      {widgetSource === 'ontario' &&
        <p>
          {t('You can benefit from a free program that helps low-income customers reduce their energy use at home, with a free energy assessment and upgrades. Energy saving devices such as energy-saving light bulbs and powerbars will be installed free of charge. To learn more about this program, check out')}&nbsp;
          <BlankLink href={`https://${t('greenon.ca/')}`} text={t('the Green Ontario Fund Website')} />.
        </p>
      }
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('Wattage of T12 lights:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_T12toT8_T12watt"
          />
        </li>
        <li>
          {t('Wattage of T8 lights:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_T12toT8_T8watt"
          />
        </li>
        <li>
          {t('Cost of each new T8 light:')}
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_T12toT8_T8cost"
          />
        </li>
        <li>
          {t('cost of electricity')}
          <InlineInput
            apiKey="input_takeaction_assumption_kwhprice"
            maxLength={3}
          />
          {t('cents per kWh')}
        </li>
      </ul>
    </div>
  </div>
);

SwitchT12ToT8Lights.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('t12ToT8'),
  connect(mapStateToProps, mapDispatchToProps)(SwitchT12ToT8Lights),
);
